import {
  IModel,
  Model,
  ModelRecord,
  SalesPackagePriceRuleOrganizationModel,
  SalesPackagePriceRuleStateModel,
  SalesPackagePriceRuleBrandModel,
  BusinessLineModel,
} from '@common/models';
import { BusinessLineEnum } from '@common/models/Enums';

export interface ISalesPackagePriceRuleModel extends IModel {
  salesPackagePriceRuleId: number;
  salesPackageId: number;
  priority: number;
  isBlocking: boolean;
  startDate: string;
  endDate: string;
  price: string;
  businessLineId: number;
  organizations: SalesPackagePriceRuleOrganizationModel[] | undefined;
  states: SalesPackagePriceRuleStateModel[] | undefined;
  brands: SalesPackagePriceRuleBrandModel[] | undefined;
  businessLine: BusinessLineModel;
}

export class SalesPackagePriceRuleModel
  extends Model
  implements ModelRecord<ISalesPackagePriceRuleModel>
{
  salesPackagePriceRuleId: number;
  salesPackageId: number;
  priority: number;
  isBlocking: boolean;
  startDate: string;
  endDate: string;
  price: string;
  businessLineId: number;
  organizations: SalesPackagePriceRuleOrganizationModel[] = [];
  states: SalesPackagePriceRuleStateModel[] = [];
  brands: SalesPackagePriceRuleBrandModel[] = [];
  businessLine: BusinessLineModel;

  constructor(params?: Partial<ISalesPackagePriceRuleModel>) {
    super(params);
    this.salesPackagePriceRuleId = _.defaultTo(
      params?.salesPackagePriceRuleId,
      0,
    );
    this.salesPackageId = _.defaultTo(params?.salesPackageId, 0);
    this.priority = _.defaultTo(params?.priority, 0);
    this.isBlocking = _.defaultTo(params?.isBlocking, false);
    this.startDate = _.defaultTo(params?.startDate, '');
    this.endDate = _.defaultTo(params?.endDate, '');
    this.price = _.defaultTo(params?.price, '');
    this.businessLineId = _.defaultTo(
      params?.businessLineId,
      BusinessLineEnum.Clinic,
    );
    _.map(
      _.orderBy(params?.organizations, (o) => o.organization?.name),
      (org) => {
        this.organizations.push(
          new SalesPackagePriceRuleOrganizationModel(org),
        );
      },
    );
    _.map(
      _.orderBy(params?.states, (o) => o.state?.name),
      (st) => {
        this.states.push(new SalesPackagePriceRuleStateModel(st));
      },
    );
    _.map(
      _.orderBy(params?.brands, (o) => o.brand?.name),
      (br) => {
        this.brands.push(new SalesPackagePriceRuleBrandModel(br));
      },
    );
    this.businessLine = params?.businessLine
      ? new BusinessLineModel(params.businessLine)
      : new BusinessLineModel();
  }
}
